/**
 * The Skip or Always 0 card's colours, in one place so every surface that
 * shows a rule reads the same.
 *
 * ALWAYS_ZERO_TONE is the one Always 0 colour: amber, the attention colour
 * (DESIGN.md 1), because Always 0 writes 0 to a live storefront. The row
 * badge, the card header badge, the Always 0 buttons and the confirm all take
 * it, always with the Ban glyph and the words, so colour is never the only
 * signal (DESIGN.md 16).
 */

/** The one Always 0 tone: border and words. */
export const ALWAYS_ZERO_TONE = 'border-amber-300 text-amber-800';
/** Badges (row, card header) add the light amber fill. */
export const ALWAYS_ZERO_BADGE_CLASS = `${ALWAYS_ZERO_TONE} bg-amber-50`;
/** Buttons (search rows, selection pill, confirms) stay white and fill on hover. */
export const ALWAYS_ZERO_BUTTON_CLASS = `${ALWAYS_ZERO_TONE} bg-background hover:bg-amber-50 hover:text-amber-900`;
/** Remove rule: orange outline, reversible (DESIGN.md 13.6), on the pill and its confirm. */
export const REMOVE_RULE_CLASS = 'border-orange-300 text-orange-700 hover:bg-orange-50 hover:text-orange-800';
